import { actionCreator,
  API_URL,
  checkHttpStatus,
  create_post_data,
  createRequestActionTypes,
  createSearchUrl,
  jsonApiHeader,
  showErrorMessage,
  showSuccessMessage,
  showWarningMessage,
} from './../../../actions/utilAction';
export { jsonApiHeader,
  actionCreator,
  checkHttpStatus,
  createSearchUrl,
  create_post_data,
  showErrorMessage,
  showSuccessMessage,
  showWarningMessage,
  API_URL,
};

export const GET_MASTERDATABYNAME = `${API_URL}/api/MasterData/MasterDataByName`;
export const GET_CLEARINGHOUSE_LIST_API = `${API_URL}/EDIGateways/GetEDIGateways`;
export const POST_CLEARINGHOUSE_API = `${API_URL}/EDIGateways/SaveUpdate`;
export const GET_CLEARINGHOUSE_DETAILS_API = `${API_URL}/EDIGateways/GetEDIGateWayById`;
export const DELETE_CLEARINGHOUSE_API = `${API_URL}/EDIGateways/DeleteEDIGateway`;
export const CLEARINGHOUSE_STATUS_ACTIVATION = `${API_URL}/EDIGateways/UpdateEDIGatewayActiveStatus`;
export const clearingHouseActionTypes = {
  get_masterdata: createRequestActionTypes('GET_MASTERSDATA'),
  get_clearinghouseList: createRequestActionTypes('GET_CLEARINGHOUSELIST'),
  get_clearinghouseDetails: createRequestActionTypes('GET_CLEARINGHOUSEDETAILS'),
  save_clearinghouseData: createRequestActionTypes('SAVE_CLEARINGHOUSEDATA'),
  delete_clearinghouseData: createRequestActionTypes('DELETE_CLEARINGHOUSEDATA'),
  patch_staff_active_status: createRequestActionTypes('PATCH_CLEARINGHOUSE_STATUS_ACTIVATION'),
};

export const MODULE = 'CLEARINGHOUSE';



// WEBPACK FOOTER //
// ./src/modules/clearing-house/constants/ApiConstants.js